import Abstract from "../../../../abstract-view/abstract.js";

import {
  createElement
} from "../../../../render/render.js";

import {CheckboxesTrigger as Lexicon} from "../../lexicon.js";

const createTriggerTemplate = (hiddenCount, isExpanded) => {
  const triggerClass = (isExpanded) ? ` filter-trigger-button_expanded` : ``;
  const triggerText = (isExpanded) ? Lexicon.SHRINK : Lexicon.EXPAND;

  return (
    `<button class="filter-trigger-button${triggerClass}" type="button">
      <span class="filter-trigger-button__text">${triggerText}</span>
      <span class="filter-trigger-button__count">${hiddenCount}</span>
    </button>`
  );
};

export default class Trigger extends Abstract {
  constructor(hiddenCount, isExpanded) {
    super();

    this._hiddenCount = hiddenCount;
    this._isExpanded = isExpanded;
    this._textElement = null;

    this._clickHandler = this._clickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
      this._textElement = this._element.querySelector(`.filter-trigger-button__text`);
    }

    return this._element;
  }

  setExpanded() {
    this._textElement.textContent = Lexicon.SHRINK;
    this._element.classList.add(`filter-trigger-button_expanded`);
  }

  setShrink() {
    this._textElement.textContent = Lexicon.EXPAND;
    this._element.classList.remove(`filter-trigger-button_expanded`);
  }

  setClickHandler(callback) {
    this._callback.click = callback;
    this._element.addEventListener(`click`, this._clickHandler);
  }

  _getTemplate() {
    return createTriggerTemplate(this._hiddenCount, this._isExpanded);
  }

  _clickHandler() {
    this._callback.click();
  }
}
